import { useEffect, useState } from 'react';

const LANDING_HERO_TIMER_DURATION_SEC = 120;

function formatHeroCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
}

export type LandingHeroCountdownProps = {
  /** Второй экземпляр рядом с уже озвучиваемым таймером — без aria-live (родитель помечает блок декоративным). */
  decorative?: boolean;
};

export function LandingHeroCountdown({ decorative = false }: LandingHeroCountdownProps) {
  const [secondsLeft, setSecondsLeft] = useState(LANDING_HERO_TIMER_DURATION_SEC);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  useEffect(() => {
    if (secondsLeft > 0) return;
    const t = window.setTimeout(() => {
      setSecondsLeft(LANDING_HERO_TIMER_DURATION_SEC);
    }, 2500);
    return () => window.clearTimeout(t);
  }, [secondsLeft]);

  const sec = Math.max(0, Math.min(LANDING_HERO_TIMER_DURATION_SEC, secondsLeft));
  const pctRemaining =
    LANDING_HERO_TIMER_DURATION_SEC > 0
      ? Math.round((sec / LANDING_HERO_TIMER_DURATION_SEC) * 1000) / 10
      : 0;
  const elapsedCoverPct = Math.min(100, Math.max(0, 100 - pctRemaining));

  return (
    <div className="cf-hero-timer-inner">
      <div
        className="cf-hero-timer-display"
        {...(!decorative
          ? {
              'aria-live': 'polite' as const,
              'aria-atomic': true,
              'aria-label': `Осталось ${formatHeroCountdown(secondsLeft)}`,
            }
          : { role: 'presentation' })}
      >
        {formatHeroCountdown(secondsLeft)}
      </div>
      <div className="cf-hero-timer-track" role="presentation">
        <div className="cf-hero-timer-track-gradient" aria-hidden />
        <div
          className="cf-hero-timer-progress-cover"
          style={{ width: `${elapsedCoverPct}%` }}
          aria-hidden
        />
      </div>
    </div>
  );
}
